export enum AssetHistoryDocumentStatus {
    DocumentNotNeeded = 0,
    DocumentExists = 1,
    DocumentDoesNotExist = 2,
    DocumentNeedsToBeGenerated = 3
}